import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import React, { useState } from 'react'
import { TransferHistoryType } from 'store/slice/call-detail/types'

import ContactInfoCard from '../ContactInfoCard'
import SidebarComponent, { SideBarProps } from './Sidebar'

const unitTranslations = {
  eq: 'یک ظرفیت',
  lt: 'کمتر از یک ظرفیت',
  gt: 'بیشتر از یک ظرفیت',
}

const getUnitTranslation = (unit: keyof typeof unitTranslations) => {
  return unitTranslations[unit] || ''
}

type Props = {
  transferHistory?: TransferHistoryType[]
}

export const Sidebar = ({ transferHistory = [] }: Props) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false)

  const sideBarProps: SideBarProps = {
    operators: [
      ...transferHistory.map((history, index) => ({
        name: history.fullName,
        position: history.userPositionLevel,
        imageUrl: history.imageUrl,
        isBusy: index === transferHistory.length - 1,
        requests: [
          ...(history.businessProduct
            ? history.businessProduct.map((product) => ({
                name: product.productName,
                quantity: `${product.quantity || '_'} ${getUnitTranslation(
                  product.unitName as any
                )}`,
              }))
            : []),
          ...(history.callCenterProductType
            ? history.callCenterProductType.map((product) => ({
                name: product.productTypeName,
                quantity: product.quantity,
              }))
            : []),
        ],
      })),
    ],
    hasArrow: true,
    startDate: new Date().toISOString(),
    isOpen: isDrawerOpen,
    onClickArrow: () => setIsDrawerOpen(!isDrawerOpen),
  }

  return (
    <>
      {/*----------------------------------overlay ---------------------------------*/}
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black/30  z-[500]"
          aria-hidden="true"
          onClick={() => setIsDrawerOpen(false)}
        />
      )}
      {/*----------------------------------end overlay ---------------------------------*/}

      {/*------------------------- handle sidebar transition for screen <1920 & more ++ if drawer is open add form to side bar & ......----------------*/}
      <div
        style={{ boxShadow: '-2px 4px 10px rgba(0, 0, 0, 0.08)' }}
        className={classNames(
          ' fixed  right-0 top-0 bottom-0 bg-white h-screen flex z-[1000]',
          `${
            isDrawerOpen
              ? 'transition-all duration-1000 ease-in-out w-[455px]  xl:w-[200px] '
              : 'transition-all ease-in-out duration-1000 w-[72px]  xl:w-[146px]'
          }`
        )}
      >
        <div
          className={classNames(
            `${
              isDrawerOpen
                ? 'transition-all duration-1000 ease-in-out  w-[151px] border-l-1 xl:w-[200px] '
                : 'transition-all ease-in-out duration-1000 w-[72px] xl:w-[146px]'
            }`
          )}
        >
          <SidebarComponent {...sideBarProps} />
        </div>

        <Transition
          show={isDrawerOpen}
          enter=" transition-all ease-in-out duration-100  delay-300"
          enterFrom=" transition-all ease-in-out  duration-200 opacity-0 w-[150px]  w-0"
          enterTo=" transition-all ease-in-out opacity-100 duration-500 w-[300px] "
          entered={'transition-all ease-in-out  duration-100 w-[327px]'}
          leave="transition-all ease-in-out duration-500 opacity-10 w-0"
          leaveFrom="transition-all ease-in-out opacity-50 opacity-10"
          leaveTo=" transition-all ease-in-out duration-200 opacity-0"
          className={'xl:hidden'}
        >
          {/*<div*/}
          {/*  className={classNames(*/}
          {/*    isDrawerOpen*/}
          {/*      ? 'transition-all delay-500 opacity-100 !block duration-500'*/}
          {/*      : 'transition-all !hidden '*/}
          {/*  )}*/}
          {/*>*/}
          <ContactInfoCard />
          {/*</div>*/}
        </Transition>
      </div>
      {/*-------------------------end  handle sidebar transition for screen <1920 & more ++ if drawer is open add form to side bar & ......----------------*/}
    </>
  )
}
export default Sidebar
